module.exports = __webpack_public_path__ + "static/media/insurance_item-03.fbac6972.svg";